var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#87CEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E0F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ground",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7CB342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#558B2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barnBody",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E53935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C62828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "roofGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D4037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3E2723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "siloGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#90A4AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sunGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFB300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rounded"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    rx: 80,
    ry: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rounded)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "url(#sky)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 100,
    r: 50,
    fill: "url(#sunGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFD54F",
    strokeWidth: 3,
    opacity: 0.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 35,
    x2: 400,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 180,
    x2: 400,
    y2: 165
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335,
    y1: 100,
    x2: 320,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465,
    y1: 100,
    x2: 480,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354,
    y1: 54,
    x2: 343,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 146,
    x2: 457,
    y2: 157
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354,
    y1: 146,
    x2: 343,
    y2: 157
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 54,
    x2: 457,
    y2: 43
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 90,
    rx: 50,
    ry: 25
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155,
    cy: 80,
    rx: 40,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 85,
    rx: 35,
    ry: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 60,
    rx: 35,
    ry: 18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330,
    cy: 52,
    rx: 30,
    ry: 16
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 340,
    rx: 250,
    ry: 80,
    fill: "#8BC34A",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 360,
    rx: 200,
    ry: 60,
    fill: "#9CCC65",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 320,
    width: 512,
    height: 192,
    fill: "url(#ground)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#689F38",
    strokeWidth: 2,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 370,
    x2: 150,
    y2: 370
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 390,
    x2: 130,
    y2: 390
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 410,
    x2: 110,
    y2: 410
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 430,
    x2: 90,
    y2: 430
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 380,
    x2: 512,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 400,
    x2: 512,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 420,
    x2: 512,
    y2: 420
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 440,
    x2: 512,
    y2: 440
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#8D6E63",
    stroke: "#6D4C41",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 300,
    width: 115,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 318,
    width: 115,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#8D6E63",
    stroke: "#6D4C41",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 290,
    width: 6,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 300,
    width: 115,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 318,
    width: 115,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 180,
    width: 45,
    height: 140,
    fill: "url(#siloGrad)",
    rx: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362,
    cy: 180,
    rx: 22.5,
    ry: 10,
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362,
    cy: 180,
    rx: 22.5,
    ry: 10,
    fill: "none",
    stroke: "#90A4AE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 220,
    x2: 385,
    y2: 220,
    stroke: "#90A4AE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 260,
    x2: 385,
    y2: 260,
    stroke: "#90A4AE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 300,
    x2: 385,
    y2: 300,
    stroke: "#90A4AE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 185 Q340 155 362 148 Q385 155 385 185",
    fill: "#B0BEC5",
    stroke: "#90A4AE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 220,
    width: 170,
    height: 100,
    fill: "url(#barnBody)",
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 260,
    x2: 330,
    y2: 260,
    stroke: "white",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 2,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 220,
    x2: 200,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 220,
    x2: 290,
    y2: 320
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "145,220 245,155 345,220",
    fill: "url(#roofGrad)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 160,
    x2: 345,
    y2: 220,
    stroke: "#795548",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 270,
    width: 54,
    height: 50,
    fill: "#4E342E",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 272,
    width: 24,
    height: 48,
    fill: "#3E2723",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 272,
    width: 24,
    height: 48,
    fill: "#3E2723",
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 296,
    r: 3,
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 296,
    r: 3,
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 180,
    width: 30,
    height: 25,
    fill: "#4E342E",
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 180,
    x2: 245,
    y2: 205,
    stroke: "#3E2723",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 192,
    x2: 260,
    y2: 192,
    stroke: "#3E2723",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 182,
    width: 12,
    height: 9,
    fill: "#FFF9C4",
    opacity: 0.6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 182,
    width: 12,
    height: 9,
    fill: "#FFF9C4",
    opacity: 0.6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 175,
    width: 10,
    height: 130,
    fill: "#8D6E63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 175,
    r: 8,
    fill: "#ECEFF1",
    stroke: "#B0BEC5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25 87 175)",
    stroke: "#B0BEC5",
    strokeWidth: 3,
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 175,
    x2: 87,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 175,
    x2: 127,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 175,
    x2: 87,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 175,
    x2: 47,
    y2: 155
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25 87 175)",
    fill: "#CFD8DC",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 175 L82 130 L92 130 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 175 L127 190 L127 200 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 175 L92 220 L82 220 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 175 L47 160 L47 150 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 175,
    r: 4,
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFB300",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 330,
    x2: 438,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 330,
    x2: 453,
    y2: 285
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 330,
    x2: 458,
    y2: 292
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470,
    y1: 330,
    x2: 473,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 330,
    x2: 478,
    y2: 295
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC107",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 438,
    cy: 285,
    rx: 4,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 453,
    cy: 280,
    rx: 4,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 458,
    cy: 287,
    rx: 4,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 473,
    cy: 283,
    rx: 4,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 478,
    cy: 290,
    rx: 4,
    ry: 8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 350,
    width: 8,
    height: 25,
    fill: "#6D4C41",
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 340,
    r: 20,
    fill: "#43A047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 348,
    r: 14,
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 346,
    r: 15,
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 512 Q230 420 235 370 Q240 340 245 320",
    fill: "none",
    stroke: "#A1887F",
    strokeWidth: 20,
    strokeLinecap: "round",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 512 Q265 420 260 370 Q255 340 250 320",
    fill: "none",
    stroke: "#A1887F",
    strokeWidth: 20,
    strokeLinecap: "round",
    opacity: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    rx: 80,
    ry: 80,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPlaceholder);
export default __webpack_public_path__ + "static/media/default_placeholder.de6269f1860a3347a2241304d656ca85.svg";
export { ForwardRef as ReactComponent };